import {env} from './environment';
import {hasHealthcareAccess} from './entitlements';

// The legacy (hash-routed) FrontierView app. It still owns the Healthcare data download wizard and
// the personalized Healthcare dashboards, so those nav items link out to it rather than embedding
// anything.
const legacyDashboardsBase = `https://${env.NODE_ENV !== 'production' ? 'staging' : ''}dashboards.frontierview.com`;

export const LEGACY_DATA_URL = `${legacyDashboardsBase}/#dx`;
export const LEGACY_DASHBOARDS_URL = `${legacyDashboardsBase}/#dashboards`;

// In local dev REACT_APP_API_DOMAIN is empty and the dev server does not proxy /redirect-me, so the
// wrapper would produce a dead relative link. Fall back to the legacy URL itself there; staging and
// production always set the domain and keep the session hand-off.
export const legacyRedirectURL = (url) =>
	env.REACT_APP_API_DOMAIN ? `${env.REACT_APP_API_DOMAIN}/redirect-me/${encodeURIComponent(url)}` : url;

export const MACRO_DASHBOARD = {
	key: 'macro',
	label: 'Macro Dashboard',
	title: 'Macro Global Collection Dashboard',
	description: 'FrontierView macroeconomic indicators and forecasts, in one interactive dashboard.',
	path: '/dashboard/macro',
	embedURL: 'https://app.astrato.io/embed/oEa26Hy',
	// Macro is part of the base FrontierView subscription; there is no product entitlement for it.
	isEntitled: () => true,
};

export const CONSUMER_DASHBOARD = {
	key: 'consumer',
	label: 'Consumer Dashboard',
	title: 'Consumer Global Collection Dashboard',
	description: 'FrontierView consumer demand indicators and forecasts, in one interactive dashboard.',
	path: '/dashboard/consumer',
	embedURL: 'https://app.astrato.io/embed/keHTaWa',
	// Open to every signed-in user since REQ-32076. It used to require the ConsumerView product, which
	// is no longer fetched at all, so the auth query does not depend on FV3Server exposing it.
	isEntitled: () => true,
};

// The legacy Healthcare pages are for Healthcare clients only. Both mirror the HEALTHCARE tab gate.
export const HEALTHCARE_DATA = {
	key: 'healthcare-data',
	label: 'Healthcare Data',
	href: LEGACY_DATA_URL,
	isEntitled: hasHealthcareAccess,
};

export const HEALTHCARE_DASHBOARD = {
	key: 'healthcare',
	label: 'Personalized Healthcare Dashboards',
	href: LEGACY_DASHBOARDS_URL,
	isEntitled: hasHealthcareAccess,
};

// The order they appear in under the DATA & DASHBOARDS nav item.
export const DATA_AND_DASHBOARDS_NAV_ITEMS = [
	MACRO_DASHBOARD,
	CONSUMER_DASHBOARD,
	HEALTHCARE_DATA,
	HEALTHCARE_DASHBOARD,
];

// Only the Astrato dashboards get an in-app route; the Healthcare pages live on the legacy app.
export const EMBEDDED_DASHBOARDS = [MACRO_DASHBOARD, CONSUMER_DASHBOARD];
